import React from 'react';
import { Atom } from 'react-loading-indicators';

interface LoaderProps {
    text?: string;
    color?: string;
    textColor?: string;
    size?: 'small' | 'medium' | 'large';
    fullScreen?: boolean;
    className?: string;
}

const Loader: React.FC<LoaderProps> = ({
    text = "Loading Please Wait",
    color = "#32cd32",
    textColor = "", // Default from user request
    size = "large",
    fullScreen = false,
    className = ""
}) => {
    const containerClasses = fullScreen
        ? "fixed inset-0 flex items-center justify-center bg-white/95 backdrop-blur-sm z-[9999]"
        : `flex items-center justify-center min-h-[400px] w-full ${className}`;

    // Split text into two parts to put icon in the middle
    // If text is "Loading Mega Jobs...", it will be "Loading" and "Mega Jobs..."
    const textParts = text.split(' ');
    const firstPart = textParts[0];
    const restPart = textParts.slice(1).join(' ');

    return (
        <div className={containerClasses}>
            <div className="flex flex-col items-center justify-center gap-4">
                {/* Loading Icon - Smaller */}
                <div className="transform scale-75 sm:scale-90">
                    <Atom color={color} size={size} />
                </div>

                {/* Text below icon - centered */}
                <div className="flex flex-col items-center justify-center gap-1">
                    <span className="text-xl sm:text-2xl font-bold text-[#1d73bb] tracking-tight uppercase animate-pulse">
                        {text}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default Loader;
